export default class ZUGFeRDListItem {
  constructor(data = {}) {
    this.id = data.id  || null;
    this.invoiceNumber = data.invoiceNumber  || null;
    this.invoiceDate = new Date(data.invoiceDate)  || null;
    this.creationTimestamp = new Date(data.creationTimestamp)  || null;
    this.buyerName = data.buyerName  || null;
    this.zugFeRDVersionId = data.zugFeRDVersionId || '230';
    this.zugFeRDProfileId = data.zugFeRDProfileId || '32';
    this.fileId = data.fileId || null;
    this.fileName = data.fileName || null;
  }

  toJSON() {
    return {
      id: this.id,
      invoiceNumber: this.invoiceNumber,
      invoiceDate: this.invoiceDate,
      creationTimestamp: this.creationTimestamp,
      buyerName: this.buyerName,
      zugFeRDVersionId: this.zugFeRDVersionId,
      zugFeRDProfileId: this.zugFeRDProfileId,
      fileId: this.fileId,
      fileName: this.fileName,
    }
  }
}